import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.5C13.4655 0.5 14.6898 1.56053 14.9482 2.95312C16.2164 3.3418 17.414 3.98301 18.4463 4.85645C20.3893 6.49985 21.6328 8.81116 21.9326 11.3428L22.0508 12.3359L20.0645 12.5703L19.9473 11.5771C19.707 9.54912 18.7109 7.70028 17.1543 6.38379C16.4049 5.74972 15.5406 5.26848 14.6211 4.95215C14.108 5.87336 13.1257 6.5 12 6.5C10.3477 6.5 9 5.15228 9 3.5C9 1.84772 10.3477 0.5 12 0.5ZM7.5 17C7.5 18.6523 6.15228 20 4.5 20C2.84772 20 1.5 18.6523 1.5 17C1.5 16.2123 1.80897 15.4962 2.30859 14.96C1.95539 13.5807 1.90126 12.1363 2.15527 10.7139L2.15625 10.7119C2.61202 8.19963 4.01238 5.96634 6.05566 4.45605L6.85938 3.86133L8.04883 5.46973L7.24414 6.06445C5.60767 7.27413 4.48826 9.06085 4.12402 11.0684C3.94752 12.0586 3.95867 13.0572 4.14746 14.0215C4.26316 14.0078 4.38074 14 4.5 14C6.15228 14 7.5 15.3477 7.5 17ZM22.5 17C22.5 18.6523 21.1523 20 19.5 20C19.231 20 18.971 19.9605 18.7227 19.8936C17.8053 20.7311 16.731 21.4026 15.5459 21.8545L15.5439 21.8555C13.1675 22.7549 10.5339 22.7216 8.17676 21.7432L7.25293 21.3604L8.01953 19.5127L8.94336 19.8965C10.8262 20.678 12.9324 20.7049 14.8359 19.9844C15.6406 19.6772 16.3817 19.2429 17.0371 18.708C16.6992 18.2226 16.5 17.634 16.5 17C16.5 15.3477 17.8477 14 19.5 14C21.1523 14 22.5 15.3477 22.5 17Z"}}]};

const HighLevelFilled = Vue.extend<IconProps>({
  name: 'HighLevelFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'high-level-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default HighLevelFilled;
